module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row g-mb-40 div-spacing-top"
  }, _vm._l((_vm.frameList), function(frame, key) {
    return _c('div', {
      key: key,
      staticClass: "col-lg-3 g-mb-30"
    }, [_c('article', [_c('div', {
      staticClass: "gray-border"
    }, [_c('swiper', {
      staticClass: "swiper-wrapper",
      attrs: {
        "options": frame.swiperOptionSingle
      }
    }, [_vm._l((frame.imageUrl), function(pic, index) {
      return _c('swiper-slide', {
        key: index
      }, [_c('div', {
        staticClass: "location_img swiper-slide",
        on: {
          "click": function($event) {
            return _vm.ShowFrameModal(frame.imageUrl, index)
          }
        }
      }, [(frame.isOutOfStock[index] || frame.isLowStock[index]) ? _c('div', {
        staticClass: "stock-banner"
      }, [_c('label', {
        staticClass: "stock-text"
      }, [_c('span', [_vm._v("Low Stock")])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "frame-pic-div",
        class: {
          'lowstock': frame.isLowStock[index], 'nostock': frame.isOutOfStock[index]
        }
      }, [_c('img', {
        staticClass: "img-fluid image-align-vert-hor",
        attrs: {
          "src": pic,
          "alt": "Loading image..."
        },
        on: {
          "error": function($event) {
            return _vm.ImageExists(pic, key, index)
          }
        }
      })])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "level3-gallery-prev swiper-button-prev",
      attrs: {
        "slot": "button-prev",
        "id": frame.idList.prevEl
      },
      slot: "button-prev"
    }), _vm._v(" "), _c('div', {
      staticClass: "level3-gallery-next swiper-button-next",
      attrs: {
        "slot": "button-next",
        "id": frame.idList.nextEl
      },
      slot: "button-next"
    })], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "g-brd-x g-brd-gray-light-v3 g-bg-white gray-border"
    }, [_c('swiper', {
      staticClass: "swiper-wrapper",
      attrs: {
        "options": _vm.swiperOption
      }
    }, _vm._l((frame.imageUrl), function(pic, index) {
      return _c('swiper-slide', {
        key: index
      }, [_c('div', {
        staticClass: "location_img swiper-slide gray-border overflow-hidden"
      }, [(frame.isOutOfStock[index] || frame.isLowStock[index]) ? _c('div', {
        staticClass: "stock-banner-sm"
      }, [_c('label', {
        staticClass: "stock-text-sm"
      }, [_c('span', [_vm._v("Low Stock")])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "center frame-thumbnail-div",
        class: {
          'lowstock': frame.isLowStock[index], 'nostock': frame.isOutOfStock[index]
        }
      }, [_c('img', {
        staticClass: "img-fluid image-align-vert-hor",
        attrs: {
          "src": pic,
          "alt": "Loading image..."
        }
      })])])])
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "g-pa-25 gray-border frame-list-description1-height"
    }, [_c('label', {
      staticClass: "g-font-weight-600 frame-label"
    }, [_vm._v("Name:")]), _vm._v(" "), _c('span', {
      staticClass: "frame-description"
    }, [_vm._v(_vm._s(frame.name))]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 mb-1 frame-label"
    }, [_vm._v("Color: ")]), _vm._v(" "), _vm._l((frame.color), function(color, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(color)), (!(index == frame.color.length - 1)) ? _c('span', [_vm._v(", ")]) : _vm._e()])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Frame Type: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.frameType) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Measurements: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "frame-description"
    }, [_vm._v(_vm._s(frame.eyeSize) + " - " + _vm._s(frame.dbl) + " - " + _vm._s(frame.templeLength))]), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
      staticClass: "g-pa-25 gray-border frame-list-description2-height"
    }, [_c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Manufacturer: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.manufacturer) + " ")]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Brand: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.frameBrand) + " ")])])])])
  }), 0), _vm._v(" "), (_vm.isModalShown) ? _c('frame-modal', {
    attrs: {
      "images": _vm.selectedImages,
      "imageIndex": _vm.imageIndex
    },
    on: {
      "close": function($event) {
        return _vm.ToggleModal()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-450f453a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-450f453a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/frameResources/frameComponents/FrameList.vue
// module id = 494
// module chunks = 3